// Centralized content for Broady Home Services

export const BRAND = {
  name: "Broady Home Services",
  tagline: "Reliable Repairs. Professional Results.",
  owner: "Deve'Naire Broady",
  phone: "(702) 608-0109",
  phoneRaw: "+17026080109",
  email: "info@devenaireb.com",
  logo: "https://customer-assets.emergentagent.com/job_broady-elite-repair/artifacts/85r20ws7_3CB1A211-2FB3-4AA7-BBCF-0853E3ECB8ED.jpeg",
  areas: [
    "Las Vegas",
    "Henderson",
    "North Las Vegas",
    "Summerlin",
    "Spring Valley",
    "Enterprise",
    "Paradise",
  ],
};

export const HERO_IMAGE =
  "https://images.pexels.com/photos/28456461/pexels-photo-28456461.jpeg";

export const SERVICES = [
  {
    title: "TV Mounting",
    desc: "Flawless mounts on any wall type with concealed cable management.",
    image:
      "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=1200&q=80",
    span: "tall",
  },
  {
    title: "Furniture Assembly",
    desc: "From flat-pack to fully built — precise, square, and rock solid.",
    image:
      "https://images.unsplash.com/photo-1581539250439-c96689b516dd?auto=format&fit=crop&w=1200&q=80",
    span: "normal",
  },
  {
    title: "Ceiling Fan Installation",
    desc: "Safe, balanced, and whisper-quiet ceiling fan installs.",
    image:
      "https://images.unsplash.com/photo-1631679706909-1844bbd07221?auto=format&fit=crop&w=1200&q=80",
    span: "normal",
  },
  {
    title: "Light Fixture Installation",
    desc: "Pendant, recessed, chandelier — perfectly aligned and wired.",
    image:
      "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=1200&q=80",
    span: "wide",
  },
  {
    title: "Drywall Repair",
    desc: "Patches, holes, and seams finished to invisible.",
    image:
      "https://images.unsplash.com/photo-1581094271901-8022df4466f9?auto=format&fit=crop&w=1200&q=80",
    span: "normal",
  },
  {
    title: "Interior Painting",
    desc: "Crisp lines, even coverage, and a finish that lasts.",
    image:
      "https://images.unsplash.com/photo-1693985120993-e9b203ce7631?auto=format&fit=crop&w=1200&q=80",
    span: "tall",
  },
  {
    title: "Door Repair",
    desc: "Sticking, sagging, or squeaky — quietly restored.",
    image:
      "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?auto=format&fit=crop&w=1200&q=80",
    span: "normal",
  },
  {
    title: "Shelving Installation",
    desc: "Floating shelves, custom built-ins, perfectly level.",
    image:
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80",
    span: "normal",
  },
  {
    title: "Smart Home Installation",
    desc: "Thermostats, locks, cameras, doorbells, and hubs configured.",
    image:
      "https://images.unsplash.com/photo-1608377205619-03a0b4c4e270?auto=format&fit=crop&w=1200&q=80",
    span: "wide",
  },
  {
    title: "Caulking",
    desc: "Clean bead lines around tubs, sinks, and windows.",
    image:
      "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&w=1200&q=80",
    span: "normal",
  },
  {
    title: "Grab Bar Installation",
    desc: "Secure, code-aligned bars for safe bathrooms.",
    image:
      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1200&q=80",
    span: "normal",
  },
  {
    title: "Bathroom Repairs",
    desc: "Faucets, fixtures, tile touch-ups, and more.",
    image:
      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1200&q=80",
    span: "tall",
  },
  {
    title: "Minor Plumbing Repairs",
    desc: "Leaks, replacements, and fixture installs handled cleanly.",
    image:
      "https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?auto=format&fit=crop&w=1200&q=80",
    span: "normal",
  },
  {
    title: "General Handyman Services",
    desc: "Your punch list, completed in one professional visit.",
    image:
      "https://images.pexels.com/photos/5502253/pexels-photo-5502253.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "wide",
  },
];

export const WHY_CHOOSE_US = [
  { title: "Licensed & Insured", desc: "Fully credentialed and covered, on every job, every time." },
  { title: "Fast Response", desc: "Quick, transparent scheduling — usually within 24 hours." },
  { title: "Honest Pricing", desc: "Clear, fair estimates with no hidden fees, ever." },
  { title: "Professional Workmanship", desc: "Meticulous craftsmanship built to outlast trends." },
  { title: "Respect for Your Home", desc: "Clean shoes, drop cloths, and a spotless finish." },
  { title: "Satisfaction Guaranteed", desc: "If it isn't right, we make it right. Period." },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Request Your Estimate", desc: "Share details and photos. We respond within hours." },
  { n: "02", title: "Schedule Service", desc: "Pick a time that fits your week. We confirm the same day." },
  { n: "03", title: "We Complete the Job", desc: "Quality craftsmanship, on-time, and tidy from start to finish." },
  { n: "04", title: "Enjoy Your Home", desc: "Sit back. We follow up to make sure you love the result." },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80", label: "Built-in Shelving" },
  { src: "https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?auto=format&fit=crop&w=1400&q=80", label: "TV Mounting" },
  { src: "https://images.unsplash.com/photo-1693985120993-e9b203ce7631?auto=format&fit=crop&w=1400&q=80", label: "Interior Painting" },
  { src: "https://images.pexels.com/photos/5502253/pexels-photo-5502253.jpeg?auto=compress&cs=tinysrgb&w=1400", label: "General Repairs" },
  { src: "https://images.unsplash.com/photo-1608377205619-03a0b4c4e270?auto=format&fit=crop&w=1400&q=80", label: "Smart Home" },
  { src: "https://images.unsplash.com/photo-1581094271901-8022df4466f9?auto=format&fit=crop&w=1400&q=80", label: "Drywall Restoration" },
  { src: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=1400&q=80", label: "Lighting Install" },
  { src: "https://images.pexels.com/photos/18947388/pexels-photo-18947388.jpeg?auto=compress&cs=tinysrgb&w=1400", label: "Craftsmanship" },
];

export const REVIEWS = [
  {
    name: "Marcus T.",
    location: "Summerlin",
    rating: 5,
    text: "Deve'Naire showed up exactly on time, mounted three TVs flawlessly with hidden wiring, and left the house spotless. I've already booked him for two more projects.",
  },
  {
    name: "Jasmine R.",
    location: "Henderson",
    rating: 5,
    text: "I've never had a handyman this professional. He answered fast, gave an honest quote, and the drywall repair is genuinely invisible. Worth every dollar.",
  },
  {
    name: "Andre P.",
    location: "Las Vegas",
    rating: 5,
    text: "Smart home install was top-tier. Set up the thermostat, locks, cameras and walked me through the apps. Felt like I hired a tech concierge.",
  },
  {
    name: "Priya S.",
    location: "Spring Valley",
    rating: 5,
    text: "Painted the entire living room and hallway in a day. Crisp edges, no drips, drop cloths everywhere. Highly recommend.",
  },
  {
    name: "Robert K.",
    location: "Paradise",
    rating: 5,
    text: "Fixed a sticking door I'd lived with for years in fifteen minutes. Also installed grab bars for my mother — kind, careful, exceptional.",
  },
];

export const FAQS = [
  {
    q: "How quickly can you schedule?",
    a: "Most projects can be scheduled within 24–72 hours of your estimate. Same-day appointments are sometimes available — just call or text and ask.",
  },
  {
    q: "Do you supply materials?",
    a: "Yes. For most small repairs we bring everything required. For larger projects we'll confirm materials with you upfront so there are no surprises.",
  },
  {
    q: "What forms of payment do you accept?",
    a: "We accept all major credit cards, debit, Zelle, Venmo, Apple Pay, cash, and check. Payment is collected once you're 100% satisfied with the work.",
  },
  {
    q: "What areas do you service?",
    a: "We serve the entire Las Vegas Valley including Las Vegas, Henderson, North Las Vegas, Summerlin, Spring Valley, Enterprise, and Paradise.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Absolutely. Broady Home Services is fully licensed and carries general liability insurance on every job — for your protection and ours.",
  },
  {
    q: "Do you offer a satisfaction guarantee?",
    a: "Yes. If something isn't right, we come back and make it right. Your home, your standards.",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);
